import { render, staticRenderFns } from "./wuyeList.vue?vue&type=template&id=0cc0705b&scoped=true&"
import script from "./wuyeList.vue?vue&type=script&lang=js&"
export * from "./wuyeList.vue?vue&type=script&lang=js&"
import style0 from "./wuyeList.vue?vue&type=style&index=0&id=0cc0705b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0705b",
  null
  
)

export default component.exports